import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import Item from './Item';
import './ListForm.scss';
var ListForm = /*#__PURE__*/function (_Component) {
  function ListForm(props) {
    var _this;
    _classCallCheck(this, ListForm);
    _this = _callSuper(this, ListForm, [props]);
    _this.state = {
      list: props.answer
    };
    _this.handleAddItem = _this.handleAddItem.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleDeleteItem = _this.handleDeleteItem.bind(_this);
    return _this;
  }
  _inherits(ListForm, _Component);
  return _createClass(ListForm, [{
    key: "handleInputChange",
    value: function handleInputChange(value, index) {
      var list = this.state.list;
      var _this$props = this.props,
        handleChange = _this$props.handleChange,
        questionKey = _this$props.questionKey;
      list[index] = value;
      this.setState({
        list: list
      });
      handleChange(list, questionKey);
    }
  }, {
    key: "handleAddItem",
    value: function handleAddItem() {
      var list = this.state.list;
      list.push('');
      this.setState({
        list: list
      });
      var _this$props2 = this.props,
        handleChange = _this$props2.handleChange,
        questionKey = _this$props2.questionKey;
      handleChange(list, questionKey);
    }
  }, {
    key: "handleDeleteItem",
    value: function handleDeleteItem(index) {
      var list = this.state.list;
      if (list.length === 1) {
        list[index] = '';
      } else {
        list.splice(index, 1);
      }
      this.setState({
        list: list
      });
      var _this$props3 = this.props,
        handleChange = _this$props3.handleChange,
        questionKey = _this$props3.questionKey;
      handleChange(list, questionKey);
    }
  }, {
    key: "renderList",
    value: function renderList() {
      var _this2 = this;
      var list = this.state.list;
      var _this$props4 = this.props,
        questionKey = _this$props4.questionKey,
        style = _this$props4.style;
      return /*#__PURE__*/React.createElement("div", {
        className: "list"
      }, list.map(function (item, index) {
        return /*#__PURE__*/React.createElement(Item, {
          value: item,
          index: index,
          handleInputChange: _this2.handleInputChange,
          handleDeleteItem: _this2.handleDeleteItem,
          itemHeader: pluralize.singular(questionKey),
          placeholder: questionKey === 'accomplishments' ? '36 INDs and 11 NDA submissions.' : 'Type here...',
          style: style
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var list = this.state.list;
      var _this$props5 = this.props,
        limit = _this$props5.limit,
        questionKey = _this$props5.questionKey;
      if (list.length === 0) {
        this.handleAddItem();
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "list-question body-text-2"
      }, this.renderList(), (limit === null || list.length < limit) && /*#__PURE__*/React.createElement("div", {
        className: "mt-3"
      }, /*#__PURE__*/React.createElement("a", {
        role: "link",
        tabIndex: 0,
        id: "add-new-item",
        onClick: function onClick() {
          return _this3.handleAddItem();
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-plus me-2"
      }), "Add another", ' ', pluralize.singular(questionKey))));
    }
  }]);
}(Component);
ListForm.propTypes = {
  answer: PropTypes.arrayOf(PropTypes.string).isRequired,
  questionKey: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  limit: PropTypes.number,
  style: PropTypes.string.isRequired
};
ListForm.defaultProps = {
  limit: null
};
export default ListForm;